// Import main styles
import '../../styles/style.scss';

// Import page style
import './style.scss';

// Get main navbar
import { navbarHelper } from '../../components/navbar/script.js';
// Prepend navbar to body
navbarHelper('main');

// Import Hero section script
import '../../components/hero/home/script.js';

// Import rating section script
import '../../components/rating/script.js';

// Import products section script
import '../../components/products/script.js';

// Import solutions section script
import '../../components/solutions/script.js';

// Import testimonials section script
import '../../components/testimonials/script.js';

// Import FAQ section script
import '../../components/faq/script.js';

// Import CTA section script
import '../../components/cta/main/script.js';

// Import Footer section script
import '../../components/footer/script.js';

// Import Floating actions section script
import '../../components/floating_actions/script.js';

// Mast be loaded after all page content loaded
// Import main script
import '../../scripts/bootstrap.js';
